import React from 'react'
import { Form, Button, Cascader, Input } from 'antd'
import styled from 'styled-components'
import { t } from '@/i18n'
import { findHostNameByAgentId } from '../../../utils'

const agentDisplayRender = (labels: string[], selectedOptions?: any[]) => {
  if (!selectedOptions || selectedOptions.length < 3) return labels.join(' / ')

  const agent = selectedOptions[2]
  return agent?.selectedLabel
}

const AgentToContainerConfig: React.FC<{
  dataOptions?: any
  onAgentChange?: (agentId: string) => void
}> = ({ dataOptions, onAgentChange }) => {
  const form = Form.useFormInstance()

  // 处理agent选择变化
  const handleAgentChange = (value: (string | number)[]) => {
    if (value && value.length === 3) {
      const agentId = String(value[2])
      const hostName = findHostNameByAgentId(agentId, dataOptions?.agentOptions || [])

      // 自动填充容器地址
      form.setFieldsValue({
        verificationMode: {
          agentToContainer: {
            hostId: hostName,
          },
        },
      })

      // 通知父组件agent选择变化，用于获取设备列表
      onAgentChange?.(agentId)
    }
  }

  return (
    <Wrapper>
      <ConfigTitle>
        <span className="config-title-label">{t('配置模式')}</span>
        <span className="config-title-value">{t('Agent → 容器')}</span>
      </ConfigTitle>

      <div className="form-item-wrapper">
        <Form.Item
          label={
            <div className="config-title-label-wrapper">
              <div className="config-title-label">{t('攻击主体')}</div>
              <div className="config-title-value" style={{ marginRight: 16 }}>
                Agent
              </div>
            </div>
          }
          name={['verificationMode', 'agentToContainer', 'agentId']}
          rules={[{ required: true, message: t('请选择攻击主体') }]}
          required
        >
          <Cascader
            placeholder={t('Agent名称/IP')}
            className="form-select"
            options={dataOptions?.agentOptions || []}
            displayRender={agentDisplayRender}
            onChange={handleAgentChange}
          />
        </Form.Item>
        <Button type="link" onClick={() => window.open('/configure/client/list')}>
          {t('添加')}
        </Button>
      </div>

      <Form.Item
        label={
          <div className="config-title-label-wrapper">
            <div className="config-title-label">{t('目标主体')}</div>
            <div className="config-title-value">{t('容器地址')}</div>
          </div>
        }
        name={['verificationMode', 'agentToContainer', 'hostId']}
        rules={[{ required: true, message: t('请选择目标主体') }]}
        required
      >
        <Input placeholder={t('容器名称 (容器地址)')} className="form-select" disabled />
      </Form.Item>
    </Wrapper>
  )
}

export default AgentToContainerConfig

const Wrapper = styled.div`
  height: 162px;
  background: #f8f9fb;
  border-radius: 6px;
  padding: 16px 16px 0 24px;
  margin: 0 0 12px 115px;

  .form-item-wrapper {
    display: flex;
    .ant-form-item-label > label {
      font-weight: 400;
    }

    .ant-btn {
      margin-left: 16px;
      padding: 6.6px 0;
    }
  }

  .config-title-label-wrapper {
    display: flex;
    align-items: center;
    .ant-form-item-label > label {
      font-weight: 400;
    }
  }

  .config-title-label {
    color: #333333;
    margin-right: 50px;
    font-weight: 400;
  }

  .config-title-value {
    color: #666666;
  }

  .form-select {
    width: 640px;
  }

  .agent-item {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .agent-item-name {
      margin-right: 12px;
    }
  }
`

const ConfigTitle = styled.div`
  font-size: 14px;
  margin-bottom: 20px;
  display: flex;

  .config-title-label {
    color: #333333;
    margin-left: 10px;
    margin-right: 50px;
  }

  .config-title-value {
    color: #86909c;
  }
`
